/* eslint-disable @typescript-eslint/camelcase */
import React, { useState, SetStateAction, useContext } from 'react';
import edit from '../../../../../../assets/img/icons/edit.png';
import loader from '../../../../../../assets/img/icons/TizetiLoaderColored.gif';
import helpers from '../../../../../../utils/helpers';
import view from '../../../../../../assets/img/icons/view.png';
import ViewBasestationConnection from './ViewBasestationConnection';
// import { BasestationConnectionProps } from './types/BasestationConnectionProps';
import BasestationConnectionContext from './context/BasestationConnectionContext';

const BasestationConnectionTable = () => {
  const { loading: load, data } = useContext(BasestationConnectionContext);
  const [one, setOne] = useState({
    created_at: '',
    deleted_at: '',
    pptp_ip: '',
    id: '',
    public_ip: '',
    private_ip: '',
    tizeti_site_id: '',
  });
  const onClick = (params) => {
    setOne(params);
  };
  const tableData =
    data && data.length
      ? data.map((row, i) => (
          <tr className="text-nowrap" key={row.id}>
            <td>{i + 1}</td>
            <td>{row.site_name}</td>
            <td>{row.network}</td>
            <td>{row.ssid}</td>
            <td>{row.ip_address}</td>
            <td>{row.product_name}</td>
            <td>{row.frequency}</td>
            <td>{row.stations}</td>
            <td>{row.host}</td>
            <td>{row.active}</td>
            <td>{row.public_ip}</td>
            <td>{row.number_of_public_ip}</td>
            <td>{helpers.formatDateAndTime(row.created_at)}</td>
            <td>
              <div className="text-center">
                <button
                  type="submit"
                  className="mr-2"
                  data-toggle="modal"
                  data-placement="right"
                  data-target="#view_access-point"
                  onClick={() => onClick(row)}
                >
                  <span className="view">
                    <img src={view} data-toggle="tooltip" alt="" data-placement="top" title="View" />
                  </span>
                </button>
                <button
                  type="submit"
                  className="mr-2"
                  data-toggle="modal"
                  data-placement="right"
                  data-target="#update_item"
                  // onClick={() => getItem(list)}
                >
                  <span className="view">
                    <img src={edit} data-toggle="tooltip" alt="" data-placement="top" title="Edit" />
                  </span>
                </button>
              </div>
              <ViewBasestationConnection view={one} />
              {/* <EditRetrievalItem OneItem={one} /> */}
            </td>
          </tr>
        ))
      : 'no basestation connection';
  return (
    <div className="card x-panel mt-2 px-0">
      <div className="table-responsive content col-12 px-1">
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Site Name</th>
              <th className="text-nowrap">Network</th>
              <th>SSID</th>
              <th>IP Address</th>
              <th>Product Name</th>
              <th>Frequency</th>
              <th>Stations</th>
              <th>Host</th>
              <th>Active</th>
              <th>Public Ip</th>
              <th className="text-nowrap">Number of Public IP</th>
              <th>Date Created</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {load ? (
              <tr>
                {/* <td colSpan="9" className="text-center"> */}
                <img src={loader} alt="loading gif" />
                {/* </td> */}
              </tr>
            ) : (
              tableData
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BasestationConnectionTable;
